import {
    VIDEO_DETAILS
} from '../actions/Types';

const INITIAL_STATE = {
    videoDetail:{}
  }
export default (state = INITIAL_STATE, action) =>
{
    switch(action.type)
    {
        case VIDEO_DETAILS:            
            return {...state, videoDetail: action.payload[0]};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/VideoReducer.js